import { render, staticRenderFns } from "./DiagnosisPlanForm.vue?vue&type=template&id=1a2b5eb0&scoped=true&"
import script from "./DiagnosisPlanForm.vue?vue&type=script&lang=js&"
export * from "./DiagnosisPlanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2b5eb0",
  null
  
)

export default component.exports